import Cookies from 'js-cookie';
import Errors from './Errors';
import {apiVersion} from './main.js';
import { resolveApiBase } from './shared/utils/resolveApiBase';

class FileForm {

  constructor(data) {
    this.originalData = data;

    for (let field in data) {
      this[field] = data[field];
    }

    this.errors = new Errors();
    this.retorno = {};
  }


  upload(url) {

    let formData = new FormData();
    this.data.forEach((item, i) => {
      if (item.label != "arquivos[]") {
        formData.append(item.label, item.value);
      }
    });

    for (var i = 0; i < this.file.length; i++) {
      formData.append('arquivos[]', this.file[i]);
    };
    // if(this.docfis != undefined){
    //   for (var i = 0; i < this.docfis.length; i++) {
    //     formData.append('docfis[]', this.docfis[i]);
    //   };
    // }

    return new Promise((resolve, reject) => {
      axios.post(resolveApiBase(apiVersion()) + url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-XSRF-TOKEN": Cookies.get('XSRF-TOKEN'),
          },
        }).then(response => {
          this.onSuccess(response.data);
          // Retorna o http status
          response.data.httpStatus = response.status;
          resolve(response.data);
        }).catch(error => {
          // 401: axios interceptor tenta refresh via /api/usuario; fallback abaixo.
          if (error.response && error.response.status == 401) {
            if (typeof window.forceSessionExpired === 'function') {
              window.forceSessionExpired();
            }
          }

          if(error.response && error.response.data && error.response.data.type==3)
          {
            this.onFail(error.response.data);

            reject(error.response.data.errors);
          }
          else
          {
            reject(error.response.data);
          }

        });
    });
  }

  /**
  * Reset the form fields.
  */
  reset() {
    for (let field in this.originalData) {
      this[field] = '';
    }

    this.errors.clear();
  }

  /**
   * Handle a successful form submission.
   *
   * @param {object} data
   */
  onSuccess(data) {
    //this.reset();
  }


  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail(errors) {
    this.errors.record(errors.errors, errors.message, errors.type);
  }

}

export default FileForm;
